import request from "../../utils/request.js";

const systemBksApi = {
  /**
   * 分页获取用户信息
   * @param {Object} parameter
   */
  pageSystemUser(parameter) {
    return request.post("/platform-room/bks/system/pageSystemUser", parameter);
  },
  /**
   * 添加管理用户信息
   * @param {Object} parameter
   */
  saveSystemUser(parameter) {
    return request.post("/platform-room/bks/system/saveSystemUser", parameter);
  },
  /**
   * 编辑管理用户信息
   * @param {Object} parameter
   */
  modifySystemUser(parameter) {
    return request.post(
      "/platform-room/bks/system/modifySystemUser",
      parameter
    );
  },
  /**
   * 用户密码修改
   * @param {Object} parameter
   */
  modifyPassword(parameter) {
    return request.post("/platform-room/bks/system/modifyPassword", parameter);
  },

  /**
   * 修改管理用户状态
   * @param {Object} parameter
   */
  modifySystemUserSta(parameter) {
    return request.get(
      "/platform-room/bks/system/modifySystemUserSta",
      parameter
    );
  },
  /**
   * 删除后台用户信息
   * @param {Object} parameter
   */
  removeSystemUser(parameter) {
    return request.get("/platform-room/bks/system/removeSystemUser", parameter);
  },
  /**
   * 查询用户角色信息
   * @param {Object} parameter
   */
  findUserRole(parameter) {
    return request.get("/platform-room/bks/system/findUserRole", parameter);
  },
  /**
   * 用户分配角色
   * @param {Object} parameter
   */
  saveUserRole(parameter) {
    return request.get("/platform-room/bks/system/saveUserRole", parameter);
  },
  /**
   * 用户登录
   * @param {Object} parameter
   */
  userLogin(parameter) {
    return request.post("/platform-room/bks/system/userLogin", parameter);
  },
  /**
   * 用户登出
   */
  userLogout() {
    return request.post("/platform-room/bks/system/userLogout");
  },
  /**
   * 查询资源信息
   * @param {Object} parameter
   */
  listPermission(parameter) {
    return request.post("/platform-room/bks/system/listPermission", parameter);
  },
  /**
   * 添加系统资源信息
   * @param {Object} parameter
   */
  savePermission(parameter) {
    return request.post("/platform-room/bks/system/savePermission", parameter);
  },
  /**
   * 修改系统资源信息
   * @param {Object} parameter
   */
  modifyPermission(parameter) {
    return request.post(
      "/platform-room/bks/system/modifyPermission",
      parameter
    );
  },
  /**
   * 删除系统资源信息
   * @param {Object} parameter
   */
  deletePermissionByCode(parameter) {
    return request.get(
      "/platform-room/bks/system/deletePermissionByCode",
      parameter
    );
  },
  /**
   * 分页获取橘色信息
   * @param {Object} parameter
   */
  pageSystemRole(parameter) {
    return request.post("/platform-room/bks/system/pageSystemRole", parameter);
  },
  /**
   * 查询角色资源信息
   * @param {Object} parameter
   */
  listRolePerm(parameter) {
    return request.get("/platform-room/bks/system/listRolePerm", parameter);
  },
  /**
   * 添加角色信息
   * @param {Object} parameter
   */
  saveSystemRole(parameter) {
    return request.post("/platform-room/bks/system/saveSystemRole", parameter);
  },
  /**
   * 编辑角色信息
   * @param {Object} parameter
   */
  modifySystemRole(parameter) {
    return request.post(
      "/platform-room/bks/system/modifySystemRole",
      parameter
    );
  },
  /**
   * 删除角色信息
   * @param {Object} parameter
   */
  removeSystemRole(parameter) {
    return request.get("/platform-room/bks/system/removeSystemRole", parameter);
  },
  /**
   * 查询省份信息
   * @param {Object} parameter
   */
  listCodeProvince(parameter) {
    return request.get("/platform-room/bks/system/listCodeProvince", parameter);
  },
  /**
   * 获取城市信息
   * @param {Object} parameter
   */
  listCodeCity(parameter) {
    return request.post("/platform-room/bks/system/listCodeCity", parameter);
  },
  /**
   * 编辑城市信息
   * @param {Object} parameter
   */
  modifyCodeCity(parameter) {
    return request.post("/platform-room/bks/system/modifyCodeCity", parameter);
  },
  /**
   * 获取城市信息(分页)
   * @param {Object} parameter
   */
  pageCodeCity(parameter) {
    return request.post("/platform-room/bks/system/pageCodeCity", parameter);
  },
  /**
   * 查询行政区域
   * @param {Object} parameter
   */
  pageCodeDistrict(parameter) {
    return request.post(
      "/platform-room/bks/system/pageCodeDistrict",
      parameter
    );
  },
  /**
   * 保存行政区域
   * @param {Object} parameter
   */
  saveCodeDistrict(parameter) {
    return request.post(
      "/platform-room/bks/system/saveCodeDistrict",
      parameter
    );
  },
  /**
   * 修改行政区域
   * @param {Object} parameter
   */
  modifyCodeDistrict(parameter) {
    return request.post(
      "/platform-room/bks/system/modifyCodeDistrict",
      parameter
    );
  },
  /**
   * 删除行政区域
   * @param {Object} parameter
   */
  removeCodeDistrict(parameter) {
    return request.get(
      "/platform-room/bks/system/removeCodeDistrict",
      parameter
    );
  },
  /**
   * 根据城市代码获取区域信息
   * @param {Object} parameter
   */
  findCodeDistrictByCityCode(parameter) {
    return request.get(
      "/platform-room/bks/system/findCodeDistrictByCityCode",
      parameter
    );
  },
  /**
   * 查询商圈
   * @param {Object} parameter
   */
  pageCodeCircle(parameter) {
    return request.post("/platform-room/bks/system/pageCodeCircle", parameter);
  },
  /**
   * 保存商圈信息
   * @param {Object} parameter
   */
  saveCodeCircle(parameter) {
    return request.post("/platform-room/bks/system/saveCodeCircle", parameter);
  },
  /**
   * 修改商圈信息
   * @param {Object} parameter
   */
  modifyCodeCircle(parameter) {
    return request.post(
      "/platform-room/bks/system/modifyCodeCircle",
      parameter
    );
  },
  /**
   * 删除商圈信息
   * @param {Object} parameter
   */
  removeCodeCircle(parameter) {
    return request.get(
      "/platform-room/bks/system/removeCodeCircle",
      parameter
    );
  },
  /**
   * 根据城市代码获取商圈信息
   * @param {Object} parameter
   */
  findCodeCircleByCityCode(parameter) {
    return request.get(
      "/platform-room/bks/system/findCodeCircleByCityCode",
      parameter
    );
  },
  /**
   * 根据区域代码获取商圈信息
   * @param {Object} parameter
   */
  findCodeCircleByDistrictCode(parameter) {
    return request.get(
      "/platform-room/bks/system/findCodeCircleByDistrictCode",
      parameter
    );
  },
  /**
   * 获取省份，城市，区域，商圈信息(下拉框)
   * @param {Object} parameter
   */
  findProvinceCityDistrictCircleHelpCode(parameter) {
    return request.post(
      "/platform-room/bks/system/findProvinceCityDistrictCircleHelpCode",
      parameter
    );
  },
  /**
   * 获取分类信息
   * @param {Object} parameter
   */
  listSystemDataKind(parameter) {
    return request.post(
      "/platform-room/bks/system/listSystemDataKind",
      parameter
    );
  },
  /**
   * 查询数据字典值
   * @param {Object} parameter
   */
  pageSystemDataDict(parameter) {
    return request.post(
      "/platform-room/bks/system/pageSystemDataDict",
      parameter
    );
  },
  /**
   * 保存字典信息
   * @param {Object} parameter
   */
  saveSystemDataDict(parameter) {
    return request.post(
      "/platform-room/bks/system/saveSystemDataDict",
      parameter
    );
  },
  /**
   * 修改字典信息
   * @param {Object} parameter
   */
  modifySystemDataDict(parameter) {
    return request.post(
      "/platform-room/bks/system/modifySystemDataDict",
      parameter
    );
  },
  /**
   * 删除字典信息
   * @param {Object} parameter
   */
  deleteSystemDataDictById(parameter) {
    return request.post(
      "/platform-room/bks/system/deleteSystemDataDictById?id=" + parameter.id,
      null
    );
  },
  /**
   * 查询系统参数
   * @param {Object} parameter
   */
  pageSystemOption(parameter) {
    return request.post(
      "/platform-room/bks/system/pageSystemOption",
      parameter
    );
  },
  /**
   * 保存系统参数
   * @param {Object} parameter
   */
  saveSystemOption(parameter) {
    return request.post(
      "/platform-room/bks/system/saveSystemOption",
      parameter
    );
  },
  /**
   * 修改系统参数
   * @param {Object} parameter
   */
  modifySystemOption(parameter) {
    return request.post(
      "/platform-room/bks/system/modifySystemOption",
      parameter
    );
  },
  /**
   * 删除系统参数
   * @param {Object} parameter
   */
  deleteSystemOptionById(parameter) {
    return request.post(
      "/platform-room/bks/system/deleteSystemOptionById?id=" + parameter.id,
      null
    );
  },
  /**
   * 查询消息通知模板信息
   * @param {Object} parameter
   */
  pageEdmTemplate(parameter) {
    return request.post("/platform-room/bks/system/pageEdmTemplate", parameter);
  },
  /**
   * 保存消息通知模板信息
   * @param {Object} parameter
   */
  saveEdmTemplate(parameter) {
    return request.post("/platform-room/bks/system/saveEdmTemplate", parameter);
  },
  /**
   * 修改消息通知模板信息
   * @param {Object} parameter
   */
  modifyEdmTemplate(parameter) {
    return request.post(
      "/platform-room/bks/system/modifyEdmTemplate",
      parameter
    );
  },
  /**
   * 删除消息通知模板信息
   * @param {Object} parameter
   */
  deleteEdmTemplateById(parameter) {
    return request.post(
      "/platform-room/bks/system/deleteEdmTemplateById?id=" + parameter.id,
      null
    );
  },
  /**
   * 查询第三方应用配置
   * @param {Object} parameter
   */
  pageThirdConfig(parameter) {
    return request.post("/platform-room/bks/system/pageThirdConfig", parameter);
  },
  /**
   * 保存第三方应用配置
   * @param {Object} parameter
   */
  saveThirdConfig(parameter) {
    return request.post("/platform-room/bks/system/saveThirdConfig", parameter);
  },
  /**
   * 修改第三方应用配置
   * @param {Object} parameter
   */
  modifyThirdConfig(parameter) {
    return request.post(
      "/platform-room/bks/system/modifyThirdConfig",
      parameter
    );
  },
  /**
   * 删除第三方应用配置
   * @param {Object} parameter
   */
  deleteThirdConfigById(parameter) {
    return request.post(
      "/platform-room/bks/system/deleteThirdConfigById?id=" + parameter.id,
      null
    );
  },
  /**
   * 查询接口服务
   * @param {Object} parameter
   */
  pageSystemService(parameter) {
    return request.post(
      "/platform-room/bks/system/pageSystemService",
      parameter
    );
  },
  /**
   * 保存接口服务信息
   * @param {Object} parameter
   */
  saveSystemService(parameter) {
    return request.post(
      "/platform-room/bks/system/saveSystemService",
      parameter
    );
  },
  /**
   * 编辑接口服务信息
   * @param {Object} parameter
   */
  modifySystemService(parameter) {
    return request.post(
      "/platform-room/bks/system/modifySystemService",
      parameter
    );
  },
  /**
   * 删除接口服务信息
   * @param {Object} parameter
   */
  removeSystemServiceById(parameter) {
    return request.post(
      "/platform-room/bks/system/removeSystemServiceById?id=" + parameter.id,
      null
    );
  },
  /**
   * 查询接口服务api
   * @param {Object} parameter
   */
  pageSystemServiceApi(parameter) {
    return request.post(
      "/platform-room/bks/system/pageSystemServiceApi",
      parameter
    );
  },
  /**
   * 保存接口服务api信息
   * @param {Object} parameter
   */
  saveSystemServiceApi(parameter) {
    return request.post(
      "/platform-room/bks/system/saveSystemServiceApi",
      parameter
    );
  },
  /**
   * 编辑接口服务api信息
   * @param {Object} parameter
   */
  modifySystemServiceApi(parameter) {
    return request.post(
      "/platform-room/bks/system/modifySystemServiceApi",
      parameter
    );
  },
  /**
   * 删除接口服务api信息
   * @param {Object} parameter
   */
  removeSystemServiceApiById(parameter) {
    return request.post(
      "/platform-room/bks/system/removeSystemServiceApiById?id=" + parameter.id,
      null
    );
  },
  /**
   * 查询系统投诉建议信息
   * @param {Object} parameter
   */
  pageSystemFeedbackRecord(parameter) {
    return request.post(
      "/platform-room/bks/system/pageSystemFeedbackRecord",
      parameter
    );
  },
  /**
   * 查询系统投诉建议反馈信息
   * @param {Object} parameter
   */
  listSystemFeedbackReplyByFeedbackNo(parameter) {
    return request.get(
      "/platform-room/bks/system/listSystemFeedbackReplyByFeedbackNo",
      parameter
    );
  },
  /**
   * 添加系统投诉建议反馈信息
   * @param {Object} parameter
   */
  saveSystemFeedbackReply(parameter) {
    return request.post(
      "/platform-room/bks/system/saveSystemFeedbackReply",
      parameter
    );
  },
};

export default systemBksApi;
